import styled from 'styled-components';

export const StartupModule = styled.div.attrs({
    className: 'styled-startup-module',
})``;
